module.exports = __webpack_public_path__ + "static/img/6.bd2b727.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/3/6/eng/6.png
// module id = C3Zb
// module chunks = 0